import { useRef, useState } from "react";

// Pinch / wheel / double-tap zoomable image for lightbox viewers
export function ZoomableImage({ src, alt = "", className = "" }) {
  const [scale, setScale] = useState(1);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);
  const start = useRef(null);
  const pinch = useRef(null);
  const clamp = (s) => Math.min(6, Math.max(1, s));
  const dist = (t) => Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY);

  const onWheel = (e) => {
    e.preventDefault();
    setScale((s) => { const n = clamp(s - e.deltaY * 0.01); if (n === 1) setPos({ x: 0, y: 0 }); return n; });
  };
  const onTouchStart = (e) => {
    if (e.touches.length === 2) { pinch.current = { d: dist(e.touches), s: scale }; setDragging(true); }
    else if (e.touches.length === 1 && scale > 1) { start.current = { x: e.touches[0].clientX - pos.x, y: e.touches[0].clientY - pos.y }; setDragging(true); }
  };
  const onTouchMove = (e) => {
    if (e.touches.length === 2 && pinch.current) {
      setScale(clamp(pinch.current.s * (dist(e.touches) / pinch.current.d)));
    } else if (e.touches.length === 1 && start.current) {
      setPos({ x: e.touches[0].clientX - start.current.x, y: e.touches[0].clientY - start.current.y });
    }
  };
  const onTouchEnd = () => {
    pinch.current = null; start.current = null; setDragging(false);
    setScale((s) => { if (s <= 1) setPos({ x: 0, y: 0 }); return s; });
  };
  const onMouseDown = (e) => { if (scale > 1) { e.preventDefault(); start.current = { x: e.clientX - pos.x, y: e.clientY - pos.y }; setDragging(true); } };
  const onMouseMove = (e) => { if (start.current && e.buttons === 1) setPos({ x: e.clientX - start.current.x, y: e.clientY - start.current.y }); };
  const onMouseUp = () => { start.current = null; setDragging(false); };
  const onDoubleClick = (e) => {
    e.stopPropagation();
    setScale((s) => { const n = s > 1 ? 1 : 2.5; if (n === 1) setPos({ x: 0, y: 0 }); return n; });
  };

  return (
    <div
      className="overflow-hidden select-none"
      style={{ touchAction: "none" }}
      onWheel={onWheel}
      onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}
      onMouseDown={onMouseDown} onMouseMove={onMouseMove} onMouseUp={onMouseUp} onMouseLeave={onMouseUp}
      onDoubleClick={onDoubleClick}
      onClick={(e) => e.stopPropagation()}
      data-testid="zoomable-image-wrap"
    >
      <img
        src={src} alt={alt} draggable={false}
        className={className}
        style={{
          transform: `translate(${pos.x}px, ${pos.y}px) scale(${scale})`,
          transition: dragging ? "none" : "transform 0.15s ease-out",
          transformOrigin: "center center",
          cursor: scale > 1 ? "grab" : "zoom-in",
        }}
      />
    </div>
  );
}
